// THE ROW STAMP ON THE WIRE (ADR-084 §3). Every row a person edits or an act judges carries `row_version`
// in its read; a stamped PATCH / PUT body may carry it back, and the server refuses the save
// `409 STALE_WRITE` when the row moved since it was read. The field is OPTIONAL on the wire: a body
// without it is written unchecked (the bot, scripts, personal tokens), the bump still happening.
import { z } from 'zod';
/** The row stamp: an integer born at 1, bumped by every meaningful write of the row. */
export const RowVersionSchema = z.number().int().positive();
/** Spread into a stamped request body — `z.object({ ...stampedBody, name: … })` — or `.extend(stampedBody)`
 *  on a derived one: the stamp the save read, optional. */
export const stampedBody = { row_version: RowVersionSchema.optional() };
/** The code a stale save answers (409) — one name both sides read. */
export const STALE_WRITE = 'STALE_WRITE';
